import { Link } from "react-router-dom";
import { LinkButton } from "@/components/LinkButton";
import { Wordmark } from "@/components/brand/Wordmark";
import { START_CTA, START_HREF } from "./content";

export function SiteFooter() {
  return (
    <footer>
      <div className="mx-auto max-w-layout px-5 py-20">
        <div className="flex flex-col items-start gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 className="wds-title-2 text-label-strong break-keep">
              첫 후기 페이지를 만들어 보세요
            </h2>
            <p className="mt-3 max-w-md text-body-1 font-regular text-label-neutral break-keep">
              업종을 고르고 후기 남길 곳 주소만 넣으면 링크와 QR이 나와요.
            </p>
            {/* TODO(image): photo of a shop owner handing a receipt with the QR printed at the bottom to a customer, 3:2, about 1200x800. Would sit to the right of this block on md+. */}
          </div>
          <LinkButton to={START_HREF} size="large">
            {START_CTA}
          </LinkButton>
        </div>

        <div className="mt-16 flex flex-col gap-4 pt-8 text-label-1 text-label-neutral shadow-[inset_0_1px_0_var(--line-normal-neutral)] sm:flex-row sm:items-center sm:justify-between">
          <Wordmark className="wds-headline-1" />
          <nav aria-label="약관" className="flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/terms" className="inline-flex min-h-12 items-center hover:text-label-normal">
              이용약관
            </Link>
            <Link
              to="/privacy"
              className="inline-flex min-h-12 items-center font-semibold hover:text-label-normal"
            >
              개인정보 처리방침
            </Link>
          </nav>
          <p>© 2026 텔뷰</p>
        </div>
      </div>
    </footer>
  );
}
